import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { MatIconModule } from '../material';
import { DragDropModule, 
  CdkDragDrop, 
  moveItemInArray,
  CdkDrag,
  CdkDropList,
  copyArrayItem
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogService } from '../services/dialog.service';
import { TaskModel } from '../models/station.model';
import { ItemListPanelConstants } from '../models/constants/item-list-panel.constants';
import { v4 as uuidv4 } from 'uuid';
import { QBuiltService } from 'src/app/modules/qbuilt/services/qbuilt-service';
import { MatTooltipModule } from '../material';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'item-list-panel',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        DragDropModule,
        CdkDrag,
        CdkDropList,
        CommonModule,
        FormsModule,
        MatSlideToggleModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatTooltipModule
    ],
    templateUrl: './item-list-panel.component.html',
    styleUrl: './item-list-panel.component.scss'
})

export class ItemListPanelComponent {
  @Input() panelType: number;
  @Input() isEditMode: boolean = false;
  @Output() stationUpdateEvent = new EventEmitter<any>();
  @Output() taskItemUpdateEvent = new EventEmitter<any>();

  //initial task list arrays
  allTasks: any[] = [];
  requiredTasks: any[] = [];
  optionalTasks: any[] = [];

  //lists used within the panels
  stationList: any[] = [];
  taskList: any[] = [];
  itemList: any[] = [];

  departments: { value: string, viewValue: string }[] = [ { value: 'All', viewValue: 'All' } ];
  deptSelected: string = '';
  deptControl = new FormControl('');
  unusedToggleStatus: boolean = false;

  form = new FormGroup({
    deptControl: new FormControl('')
  })
  

  // Panel Variables
  panelTitle: string = '';
  deptDropdown: boolean = false;
  unusedToggle: boolean = false;
  unusedToggleText: string = "Show Unused Items";
  searchBar: boolean = false;
  requiredWarning: boolean = false;
  warningTooltip: string = '';
  panelTooltip: string = '';
  setupTooltip: string = '';
  ogItemContainer: string = 'parentList';

  allRequired: boolean = false;

  //search bar variables
  searchText: string = '';
  searchActive: boolean = false;
  filteredList: any[] = [];

  hasConfiguration: boolean = false;
  classificationMap = new Map<number, any[]>();

  constructor(
    private dialogService: DialogService, 
    private qbuiltService: QBuiltService,
    public itemConstants: ItemListPanelConstants,
    public activatedRoute: ActivatedRoute
  ) {
    this.qbuiltService.secondFormData$.subscribe(data => {
      this.stationList = data || [];
    });

    this.allTasks = JSON.parse(localStorage.getItem('configuredTasks') || '[]');
    this.allRequired = sessionStorage.getItem('allRequired') === 'true' ? true : false;
    this.hasConfiguration = sessionStorage.getItem('hasConfiguration') === 'true' ? true : false;
  }

  ngOnInit() {
    this.getTasksByKind();
    //assigns already existing station list to both panel windows
    this.stationList = JSON.parse(sessionStorage.getItem('secondFormGroup') || '[]').stationList || [];
   
    if(this.stationList.length > 0) {
      this.trackStationItems(this.stationList);
      this.checkRequiredCount();
    }

    //check for configuration - if true disabled delete/creation of stations
    this.hasConfiguration = localStorage.getItem('hasConfiguration') === 'true' ? true : false;
  }

  /**
   * Sets up the initial data for required tasks and AOC optional tasks
   * @param tasks 
   * @param panelType 
   */
  setupData(tasks: any[], panelType: number) {
    //get required tasks and AOC optional tasks and put into separate arrays
    if(panelType === 1) {
      this.panelTitle = this.itemConstants.requiredPanelTitle;
      this.deptDropdown = true;
      this.unusedToggle = true;
      this.searchBar = true;
      this.requiredWarning = true;
      this.warningTooltip = this.itemConstants.requiredWarningTooltip;
      this.panelTooltip = this.itemConstants.emptyTextSidePanel;
      this.setupTooltip = this.itemConstants.emptyTextSetupPanel;
      this.itemList = this.getRequired(tasks);
      this.setupDepartmentData(panelType);
    } else if(panelType === 2) {
      this.panelTitle = this.itemConstants.optionalPanelTitle;
      this.deptDropdown = false;
      this.unusedToggle = true;
      this.searchBar = true;
      this.requiredWarning = false;
      this.itemList = this.getOptionalTasks(tasks);
      this.optionalTasks = this.itemList;
      this.qbuiltService.setCurrentItemList(this.itemList);
    }
  }
  
getTasksByKind() {
  this.qbuiltService.GetAllTasksByKinds();
  this.qbuiltService.tasksByKindData$.subscribe((data) => {
    this.buildClassificationMap(data.Items);

    this.setupData(this.allTasks, this.panelType);
  });
}


    buildClassificationMap(tasksByKind: any[]) {
    tasksByKind.forEach(t => {
      this.classificationMap.set(
      Number(t.InspectionTaskId),
      t.ClassificationAssignments || []
    );
    });
  }

  getOptionalTasks(tasks: any[]) {
  const optionalOnly = tasks.filter(t => t.RequiredFlag === false);

  this.optionalTasks = optionalOnly.map(task => {
    return {
      taskId: task.InspectionTaskId,
      taskType: this.itemConstants.optionalItem,
      taskName: task.InspectionTaskName,
      taskDepartments: task.InspectionTaskDepartments,
      classificationAssignments: this.classificationMap.get(task.InspectionTaskId) || []
    };
  });

  const taskListItems = this.optionalTasks.map(t => t.taskId);
  sessionStorage.setItem('optionalTaskIds', JSON.stringify(taskListItems));
  this.qbuiltService.setOptionalTasks(this.optionalTasks);
  return this.optionalTasks;
}

  //setups all required tasks
getRequired(tasks: any[]) {
  const requiredOnly = tasks.filter(t => t.RequiredFlag === true);

  this.requiredTasks = requiredOnly.map(task => {
    return {
      taskId: task.InspectionTaskId,
      taskType: this.itemConstants.requiredItem,
      taskName: task.InspectionTaskName,
      taskDepartments: task.InspectionTaskDepartments,
      classificationAssignments: this.classificationMap.get(task.InspectionTaskId) || []
    };
  });

  const taskListItems = this.requiredTasks.map(t => t.taskId);
  sessionStorage.setItem('requiredTaskIds', JSON.stringify(taskListItems));
  this.qbuiltService.setAllRequiredTasks(this.requiredTasks);

  return this.requiredTasks;
}

isOverflowing(el: HTMLElement): boolean {
  return el.scrollWidth > el.clientWidth;
}


getDisplayTaskName(task: any): string {
  // Always pull from classificationMap
const assignments = this.classificationMap.get(Number(task.taskId)) || [];

  if (assignments.length === 0) {
    return task.taskName;
  }

  const subtypes = assignments
    .filter(ca => ca.Classification?.Type?.toLowerCase() !== 'department')
    .map(ca => ca.Classification.SubType);

  if (subtypes.length > 0) {
    return `<b>(${subtypes.join(', ')})</b> ${task.taskName}`;
  }

  return task.taskName;
}


  //Checks against List containing used task ids then updates styling of item panel
  checkTaskInUse(taskId: string): boolean {
    let itemsInUse = JSON.parse(sessionStorage.getItem('stationItems') || '[]');
    return itemsInUse.includes(taskId);
  }

  // Gets all possible departments from required tasks for department dropdown values
setupDepartmentData(panelType: number) {
  const sourceTasks = panelType === 1 ? this.requiredTasks : this.optionalTasks;

  sourceTasks.forEach(task => {
    task.taskDepartments.forEach((department: any) => {
      const name = department.DepartmentName;

      if (!this.departments.some(d => d.value === name)) {
        this.departments.push({
          value: name,
          viewValue: name
        });
      }
    });
  });

  // Restore previously selected department if available
  const saved = sessionStorage.getItem('selectedDepartment');
  if (saved) {
    this.deptSelected = saved;
    this.deptControl.setValue(saved);
    this.filterTaskByDepartment(this.deptSelected);
  }
}

// Handles changes to the department dropdown
onDepartmentChange(event: any) {
  this.deptSelected = event.value;
  this.deptControl.setValue(event.value);
    sessionStorage.setItem('selectedDepartment', event.value);
    //will add logic here to call backend to retrieve item lists based on selected department
    this.filterTaskByDepartment(this.deptSelected);
  }

  /***
   * Captures user change to department filter
   * pulls only items containing the selected department and assigns
   * 'currentItemList' observable
   */
filterTaskByDepartment(department: string) {
  const sourceTasks = this.panelType === 1 ? this.requiredTasks : this.optionalTasks;
  if (department === 'All') {
    this.itemList = [...sourceTasks];
  } else {
    this.itemList = sourceTasks.filter((item: any) =>
      item.taskDepartments?.some(
        (dept: any) => dept.DepartmentName === department
      )
    );
  }

  this.qbuiltService.setCurrentItemList(this.itemList);
}


  //Search Functionality
  searchPanel(searchText: string) {
    this.qbuiltService.setCurrentItemList(this.itemList);
    this.filteredList = this.itemList.filter(item => item.taskName.toLowerCase().includes(searchText.toLowerCase()));
    this.itemList = [];
    this.itemList = this.filteredList;
    this.searchActive = true;
  }

  //clear search bar
  clearSearch() {
    this.searchText = '';
    this.filteredList = [];
    this.qbuiltService.getCurrentItemList().subscribe((data) => {
      this.itemList = data || [];
    });
    this.searchActive = false;
  }

  // Handles the drag and drop event from task panel to station setup panel
drop(event: CdkDragDrop<any[]>) {
  if (event.previousContainer === event.container) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  } else {
    if (event.previousContainer.data[event.previousIndex]) {
      // Extract the dragged item
      const dragItem = event.item.data as TaskModel;
 
      // Create a new item with a unique ID
      const newItem = {
        taskId: dragItem.taskId,
        id: uuidv4(),
        taskName: dragItem.taskName,
        taskType: dragItem.taskType,
        taskDepartments: dragItem.taskDepartments,
        classificationAssignments: dragItem.classificationAssignments
      };

      //dragging item from new station vs between stations to prevent duplicates
      if(event.previousContainer.id === this.ogItemContainer) {
        copyArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );

        event.container.data[event.currentIndex] = newItem;
      } else {
        event.container.data.splice(event.currentIndex, 0, newItem);
        event.previousContainer.data.splice(event.previousIndex, 1);
      }
    }
 
    this.trackStationItems(this.stationList);
    this.emitStationUpdateEvent(this.stationList);
  }
}

  trackStationItems(stationList: any[]) {
    let stationItems: any[] = [];
    stationList.forEach(station => {
      station.taskGroup.forEach((taskgroup: any) => {
        taskgroup.taskList.forEach((task: any) => {
          //only push unique taskIds to the array
          if(!stationItems.includes(task.taskId.toString())) {
            stationItems.push(task.taskId.toString());
          }
        });
      });
    });
    sessionStorage.setItem('stationItems', JSON.stringify(stationItems));
  }

  // Edit Station Functionality to trigger dialog
  editStation(group: any) {
    const dialogRef = this.dialogService.openStationDialog(
      this.itemConstants.dialogEditTitle,
      this.itemConstants.dialogInputTitle,
      this.itemConstants.dialogInputPlaceholder,
      group.name,
      this.itemConstants.dialogCancelButtonText,
      this.itemConstants.dialogEditConfirmButtonText,
    );

    dialogRef.afterClosed().subscribe((result) => {
      if(result === undefined || result === '') {
        //user clicked cancel - do nothing
      } else {
        //update the name here
        const stationIndex = this.stationList.findIndex(station => station.id === group.id);
        if (stationIndex !== -1) {
          this.stationList[stationIndex].name = result;
        }
        this.emitStationUpdateEvent(this.stationList);
      }
    });
  }

  // Delete Station Functionality
  deleteStation(group: any) {
    this.stationList = this.stationList.filter(station => station.id !== group.id);
    this.emitStationUpdateEvent(this.stationList);
  } 

  // Add New Station Functionality and triggers dialog to name new Station
  addStation() {
    const dialogRef = this.dialogService.openStationDialog(
      this.itemConstants.dialogAddTitle,
      this.itemConstants.dialogInputTitle,
      this.itemConstants.dialogInputPlaceholder,
      this.itemConstants.dialogInputValue,
      this.itemConstants.dialogCancelButtonText,
      this.itemConstants.dialogAddConfirmButtonText,
    );

    //get response when user confirms and reset the form
    dialogRef.afterClosed().subscribe((result) => {
      if(result === undefined || result === '') {
        //user clicked cancel - do nothing
      } else {
        this.stationList.push({
          id: (this.stationList.length + 1).toString(),
          name: result,
          order: this.stationList.length + 1,
          taskGroup: [{
            id: (this.stationList.length + 1).toString(),
            name: result,
            taskList: [] = []
          }]
        });
        
        this.emitStationUpdateEvent(this.stationList);
      }
    });
  }

  // deleting task from Station setup panel
  deleteTask(stationPassed: any, task: any) {
    const stationIndex = this.stationList.findIndex(station => station.id === stationPassed.id);
    if (stationIndex !== -1) {
      this.stationList[stationIndex].taskGroup = this.stationList[stationIndex].taskGroup.filter(
        (taskGroup: any) => {
          taskGroup.taskList = taskGroup.taskList.filter((t: any) => t.id !== task.id);
          return taskGroup;
        }
      );

      this.trackStationItems(this.stationList);
      this.emitStationUpdateEvent(this.stationList);
    }
  }

  /**
   * Emits changes to the Required Items form
   * to the parent component
   * @param data 
   */
  emitStationUpdateEvent(data: any) {
    this.qbuiltService.updateSecondFormData(data);
    if(this.panelType == 1) {
      this.checkRequiredCount();
    }

    this.stationUpdateEvent.emit(data);
  }

  //disabled 'delete station' button if station contains tasks
  checkEmptyStation(station: any) {
    return station.taskGroup[0].taskList.length === 0;
  }

  checkRequiredCount() {
    //setup empty arrays for taskIds
    const statListItems: any[] = sessionStorage.getItem('stationItems') ? JSON.parse(sessionStorage.getItem('stationItems') || '[]') : [];
    const taskListItems: any[] = sessionStorage.getItem('requiredTaskIds') ? JSON.parse(sessionStorage.getItem('requiredTaskIds') || '[]') : [];

    let setA = new Set(taskListItems)
    let setB = new Set(statListItems);

    if([...setA].every(value => setB.has(value))) {
      this.allRequired = true;
      sessionStorage.setItem('allRequired', 'true');
      this.qbuiltService.setAllRequiredItemsStatus(true);
    } else {
      this.allRequired = false;
      sessionStorage.setItem('allRequired', 'false');
      this.qbuiltService.setAllRequiredItemsStatus(false);
    }

  }

  ngOnDestroy() {
    sessionStorage.removeItem('selectedDepartment');
    sessionStorage.removeItem('stationItems');
    sessionStorage.removeItem('requiredTaskIds');
    sessionStorage.removeItem('optionalTaskIds');
  }

}